export enum ELanguageType {
  HEBREW = 'hebrew',
  ENGLISH = 'english',
}

export enum ETextAnchor {
  START = 'start',
  MIDDLE = 'middle',
  END = 'end',
}

export enum ETextAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
